import { CreateProviderLocationMappingInput, ProviderLocationMapping } from '@/models/gen/graphql';
import { HandleErrorInput, handleError } from '@/utils/custom';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { CreateProviderLocationMappingBulkDocument } from '@/api/queries';
import { GraphApiMethod } from '@/api/core';
import graphApi from '@/api';

// Global Service Variables
const onError = (res: HandleErrorInput): void => handleError(res, { notification: { title: 'Create Client Mapping' } });

type ServiceMethodPayload = { [key in keyof CreateProviderLocationMappingInput]: any }[];
interface ServiceMethod {
  (payload: ServiceMethodPayload): Promise<ProviderLocationMapping[]>;
}

// CreateProviderLocationMappingBulk Service
export const { createProviderLocationMappingBulk, useCreateProviderLocationMappingBulk } = ((): {
  createProviderLocationMappingBulk: ServiceMethod;
  useCreateProviderLocationMappingBulk: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [mutate] = graphApi(CreateProviderLocationMappingBulkDocument, {
    onError,
  }).map(
    (fn: GraphApiMethod<typeof CreateProviderLocationMappingBulkDocument>): ServiceMethod =>
      async (payload: ServiceMethodPayload): Promise<ProviderLocationMapping[]> => {
        const values: CreateProviderLocationMappingInput[] = payload.map(
          (mapping: CreateProviderLocationMappingInput): CreateProviderLocationMappingInput => ({ active: 1, ...mapping })
        );
        const res = await fn({ input: { values } });
        return (
          res?.createProviderLocationMappingBulk?.output?.map(
            ({ node }: { node: ProviderLocationMapping }): ProviderLocationMapping => node
          ) || []
        );
      }
  );

  const useService = createGraphApiHook(mutate, { bubble: true });
  return {
    createProviderLocationMappingBulk: mutate,
    useCreateProviderLocationMappingBulk: useService,
  };
})();
